import requestUtil from '../../helpers/requestUtil';
import {
    resetError, setError, setMessages, setTotalCount, setLodingFlagDecrement,
    setLodingFlagIncrement,
    setInboxHeaderCount,
    setInboxHeaderMessages,
    setTextNotificationHeaderCount,
    setTextNotificationHeaderMessages, setGpsData, setCount
} from './slice';

export function resetErrorStatus() {
    return async dispatch => {
        dispatch(resetError());
    };
}

export function getNotificationsData({ url, params }) {
    return async dispatch => {
        dispatch(setLodingFlagIncrement());
        try {
            const response = await requestUtil(`${url}`, 'POST', { ...params });
            dispatch(setMessages(response.candidateEmployerMessages));
            dispatch(setTotalCount(response.totalCount));
            if (response?.inboxMail) {
                dispatch(setInboxHeaderCount(response?.inboxMailCount))
                dispatch(setInboxHeaderMessages(response?.inboxMail))
            }
            if (response?.inboxMessageCount) {
                dispatch(setTextNotificationHeaderCount(response?.inboxMessageCount))
                dispatch(setTextNotificationHeaderMessages(response?.inboxMessages))
            }
            if (response?.candidatesIncidentReportings || response?.candidatesIncidentReportingsCount) {
                dispatch(setGpsData({ count: response?.candidatesIncidentReportingsCount, data: response?.candidatesIncidentReportings }))
            }
        } catch (error) {
            dispatch(setError(error.message))
        }
        finally {
            dispatch(setLodingFlagDecrement())
        }
    };
}

export const getNotificationCounts = (url) => {
    return async (dispatch) => {
        dispatch(setLodingFlagIncrement());
        try {
            const counts = await requestUtil(
                `${url}/Messaging/get-employer-notify-counts`,
                'GET'
            );
            dispatch(setCount(counts))
        } catch (error) {
            dispatch(setError(error.message))
        } finally {
            dispatch(setLodingFlagDecrement())
        }
    };
}

export const getNotificationsData1 = async (url) => {
    try {
        const data = await requestUtil(
            url,
            'GET'
        );
        return data
    } catch (error) {
        return error.message
    }
}